<template>
  <div>
    <el-row>
      <el-col>
        <h4 class="h4">
          <i class="el-icon-s-management"></i>&nbsp;&nbsp;投稿须知
        </h4></el-col
      >
      <el-col> <h2 class="h4">投稿须知</h2></el-col>
      <el-col class="left">
        <ul class="ul">
          <li>请投稿人在提交前确认以下三项:</li>
          <br />
          <li>
            认真阅读主页上的"投稿指南"，并按照规定的版面格式处理好稿件和附加文件。
          </li>
          <br />
          <li>保证这是原创成果，没有抄袭现象，没有一稿两投。</li>
          <br />
          <li>稿件如通过评审发表，版权就属于本刊所有。</li>
          <br />
          <br />
          <strong
            ><el-checkbox
              v-model="agreecheckbox"
              class="center"
              @click.native="agree"
              >我已阅读本杂志的作者提交指南。</el-checkbox
            ></strong
          >
        </ul>
        <br />
        <br />
      </el-col>
      <el-col class="h4">
        <el-button class="save" :disabled="nextdisabled" @click="iKnow()"
          >知道了</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
module.exports = {
  name: "SubmissionsComponent",

  data() {
    return {
      agreecheckbox: false,
      nextdisabled: true,
    };
  },

  methods: {
    iKnow() {
      this.$message({
        message: "已知晓",
        type: "success",
      });
    },
    clickIt: function () {
      window.location.href = "/manuscriptInfoComponent";
    },
    agree() {
      this.nextdisabled = this.agreecheckbox;
    },
    next() {
      console.log(1);
      window.eventBus.$emit("../components/manuscriptInfoComponent"); // 不带参数
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}
.ul {
  list-style: none;
}
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.ts {
  width: 150px;
  border-color: #12696e;
  border-width: 1px;
  border-radius: 0px;
}
.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}
button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/submissionsComponent.vue